import Vue from 'vue'
import Vuex from 'vuex'

import getters from './getters'
import app from './modules/app'
import auth from './modules/auth'
import user from './modules/user'
import form from './modules/form'
import answer from './modules/answer'
import notification from './modules/notification'
import exports from './modules/exports'
import axios from './modules/axios'
//import item from './modules/item'
//import category from './modules/category'
//import seller from './modules/seller'
//import user from './modules/user'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        app,
        axios,
        auth,
        user,
        form,
        answer,
        notification,
        exports,
    },
    getters
})

export default store

